class AldenoProductCarousel extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const slides = [...this.querySelectorAll('.aldeno-product-slide')];
    let current = 0;
    this.querySelectorAll('[data-product-step]').forEach(button => button.addEventListener('click', () => {
      slides[current].hidden = true;
      current = (current + Number(button.dataset.productStep) + slides.length) % slides.length;
      slides[current].hidden = false;
      this.querySelector('.aldeno-product-status').textContent = `${current + 1} / ${slides.length}`;
    }));
    slides.forEach(slide => {
      const rail = slide.querySelector('.aldeno-product-images');
      const dots = [...slide.querySelectorAll('[data-image-index]')];
      const go = index => rail.scrollTo({left: index * rail.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      dots.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
      // Native scrolling handles touch; pointer capture adds mouse/pen dragging.
      let drag;
      rail.addEventListener('dragstart', event => event.preventDefault());
      rail.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        drag = {id: event.pointerId, x: event.clientX, left: rail.scrollLeft};
        rail.setPointerCapture(event.pointerId);
        rail.style.scrollSnapType = 'none';
        event.preventDefault();
      });
      rail.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        rail.scrollLeft = drag.left + drag.x - event.clientX;
      });
      const endDrag = event => {
        if (!drag || event.pointerId !== drag.id) return;
        const index = Math.round(rail.scrollLeft / Math.max(1, rail.clientWidth));
        drag = null;
        rail.style.removeProperty('scroll-snap-type');
        if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
        go(index);
      };
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      rail.addEventListener('lostpointercapture', endDrag);
      rail.addEventListener('scroll', () => {
        const index = Math.round(rail.scrollLeft / Math.max(1, rail.clientWidth));
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      }, {passive: true});
      rail.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const index = Math.round(rail.scrollLeft / Math.max(1, rail.clientWidth));
        go(Math.max(0, Math.min(dots.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1))));
      });
    });
  }
}
if (!customElements.get('aldeno-product-carousel')) customElements.define('aldeno-product-carousel', AldenoProductCarousel);
